import React from "react";

interface ConditionalWrapperProps {
	condition: boolean;
	wrapper: (children: React.ReactNode) => React.ReactNode;
	children: React.ReactNode;
}

export function ConditionalWrapper({
	condition,
	wrapper,
	children,
}: ConditionalWrapperProps) {
	return condition ? wrapper(children) : children;
}
